<template>
  <v-container>
    <v-alert
      v-if="errorMessage"
      type="error"
      dismissible
      class="mb-4"
      @input="clearError"
    >
      <strong>Import Failed:</strong> {{ errorMessage }}
    </v-alert>
    <v-alert
      v-if="porukaSpajanja"
      type="info"
      dense
      text
      class="mb-2"
    >{{ porukaSpajanja }}</v-alert>

    <v-file-input
      label="Upload Items Spreadsheet (.xlsx)"
      accept=".xlsx, .xls"
      prepend-icon="mdi-file-excel"
      outlined
      @change="handleXlsxUpload"
    ></v-file-input>

    <v-card v-if="itemsArray.length" class="mt-5">
      <v-card-title>
        <v-row>
            <v-col cols="12" sm="6">
                Verified Items/Učitane stavke (Total: {{ itemsArray.length }})
            </v-col>
            <v-col cols="12" sm="3" v-if="itemsArray.length > 0" >
                <v-btn text small color="primary" @click="loadToStore" class="mr-1">
                   Prenesi u dokument
                </v-btn>
            </v-col>
        </v-row>
      </v-card-title>
      
      <v-data-table
        :headers="headers"
        :items="itemsArray"
        :items-per-page="10"
        class="elevation-1"
      ></v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import * as XLSX from 'xlsx'
import {defDocumentDetail, defNewDocumentDetail} from '../Document/documentHelper'
import { round, parseNum } from '@/snippets/allSnippets'
import { dohvatiSifrarnik, spojiStavku } from '@/snippets/spojiSaSifrarnikom'

export default {
  name: 'XlsxImporter',
  data() {
    return {
      itemsArray: [],
      errorMessage: '',
      porukaSpajanja: '',
      // Vuetify 2 uses 'text' (display label) and 'value' (object key matching)
      headers: [
        { text: 'Item ID - Šifra', value: 'itemId', sortable: true },
        { text: 'Item Name - Naziv', value: 'itemName', sortable: true },
        { text: 'Item Pcs - Kol', value: 'itemPcs', sortable: true },
        { text: 'Supplier Price - Dob.cijena', value: 'itemSupplierPrice', sortable: true },
        { text: 'Price - Cijena Netto', value: 'itemPrice', sortable: true },
        { text: 'VAT% - PDV %', value: 'itemVAT', sortable: true },
        { text: 'Group - Grupa', value: 'itemGroup', sortable: true },
      ],
      activItems: []
    }
  },
  methods: {
    handleXlsxUpload(file) {
      // Clear previous execution state
      this.errorMessage = ''
      this.porukaSpajanja = ''
      this.itemsArray = []

      // Vuetify 2's @change passes the raw File object directly (or null if cleared)
      if (!file) return

      const reader = new FileReader()
      reader.readAsArrayBuffer(file)
      
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          
          // Parse raw rows
          const rawData = XLSX.utils.sheet_to_json(worksheet)

          // 1. Strict Size Check (< 1,000 items)
          if (rawData.length >= 1000) {
            throw new Error(`The file contains ${rawData.length} rows. Uploads must be strictly less than 1,000 items.`)
          }

          // 2. Structural Validation
          const validatedData = this.validateAndMapSchema(rawData)
          
          // Update Vue 2 array state safely
          this.itemsArray = validatedData

        } catch (error) {
          this.errorMessage = error.message
        }
      }
    },

    validateAndMapSchema(rawRows) {
      return rawRows.map((row, index) => {
        const rowNum = index + 2 // Account for array index offset + Excel header row

        // Clean & Format Text Fields
        const itemId = row.itemId ? String(row.itemId).trim() : null
        const itemName = row.itemName ? String(row.itemName).trim() : null
        
        // Handle Numeric conversions strictly
        const itemPrice = row.itemPrice !== undefined ? Number(row.itemPrice) : NaN
        const itemPcs = row.itemPcs !== undefined ? Number(row.itemPcs) : NaN
        const itemSupplierPrice = row.itemSupplierPrice !== undefined ? Number(row.itemSupplierPrice) : NaN
        const itemVAT = row.itemVAT !== undefined ? Number(row.itemVAT) : NaN
        
        // Optional Field
        const itemGroup = row.itemGroup ? String(row.itemGroup).trim() : ''

        // Assert Mandatory Values exist
        if (!itemId) {
          throw new Error(`Row ${rowNum}: 'itemId' is required and cannot be blank.`)
        }
        if (!itemName) {
          throw new Error(`Row ${rowNum}: 'itemName' is required and cannot be blank.`)
        }
         if (isNaN(itemPcs)) {
          throw new Error(`Row ${rowNum}: 'itemPcs' is missing or not a valid number.`)
        }
        if (isNaN(itemPrice)) {
          throw new Error(`Row ${rowNum}: 'itemPrice' is missing or not a valid number.`)
        }
        if (isNaN(itemSupplierPrice)) {
          throw new Error(`Row ${rowNum}: 'itemSupplierPrice' is missing or not a valid number.`)
        }

        return {
          itemId,
          itemName,
          itemPcs,
          itemSupplierPrice,
          itemPrice,
          itemVAT,
          itemGroup: itemGroup || 'N/A'
        }
      })
    },

    clearError() {
      this.errorMessage = ''
    },
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min) ) + min;
    },
    // Korisniku treba reci koliko je stavaka povezano sa sifrarnikom, jer o
    // tome ovisi koliko posla ostaje rucno.
    javiSpajanje (sifrarnik) {
      let spojeno = 0
      let visestruko = 0
      this.activItems.forEach(stavka => {
        const sifraDob = String(stavka.ItemSuppCode || '').trim()
        if (stavka.itemID) { spojeno += 1; return }
        if (sifraDob && sifrarnik.visestruke.indexOf(sifraDob) !== -1) { visestruko += 1 }
      })
      const ukupno = this.activItems.length
      let poruka = 'Učitano ' + ukupno + ', povezano sa šifrarnikom ' + spojeno
      if (visestruko > 0) {
        poruka += ', ' + visestruko + ' sa šifrom dobavljača na više artikala'
      }
      if (ukupno - spojeno > 0) {
        poruka += '. Ostalo treba povezati ručno.'
      }
      this.porukaSpajanja = poruka
    },
    async loadToStore() {
        this.activItems.length = 0
        this.activItems = [...this.$store.state.documentActivItems]
        // Sifrarnik se dohvaca jednom za cijeli uvoz.
        const sifrarnik = await dohvatiSifrarnik(this.$store.state.companyid)
        if (this.itemsArray  && this.itemsArray.length > 0) {
          console.log('this.itemsArray: ', this.itemsArray);
          this.itemsArray.map(st => {

            let documentDet = defDocumentDetail()
            documentDet = {...documentDet, ...defNewDocumentDetail()}
            const newId = this.getRndInteger(1000000000, 9000000000)

            const itemId = st?.itemId ?? ''

            const itemName = st.itemName ? st.itemName : ''
            const itemPcs = st?.itemPcs ?? 0
            const itemSupplierPrice = st?.itemSupplierPrice ?? 0
            const itemPrice = st.itemPrice
            const itemVAT = st.itemVAT
            const itemGroup = st.itemGroup !== 'N/A' ? st.itemGroup : null

            documentDet.id = newId
            documentDet.itemName = itemName
            documentDet.ItemSuppCode = itemId
            //documentDet.ItemEANCode =st?.barcode ?? ''
            documentDet.itemGroup = itemGroup ? itemGroup : ''
            documentDet.itemGroupName = itemGroup ? itemGroup : ''
            documentDet.itemPcsPlus = itemPcs
            documentDet.itemSuppBasePrice = itemSupplierPrice
            documentDet.itemSuppDiscount = 0
            documentDet.itemSuppBasePriceAmount  = round((itemSupplierPrice * itemPcs),2)
            documentDet.itemSuppPriceAmount = round((itemSupplierPrice * itemPcs),2)
            documentDet.itemSuppDiscountAmount = 0
            documentDet.itemSuppPrice = itemSupplierPrice
            documentDet.itemPrice = itemPrice
            documentDet.itemVAT1Percentage = itemVAT
            documentDet.itemBaseAmount = round((itemPrice * itemPcs),2)
            documentDet.itemBaseForeAmount = round((itemPrice * itemPcs),2)
            documentDet.itemBaseAmountNoVAT = round((itemPrice * itemPcs),2)
            documentDet.itemBaseForeAmountNoVAT = round((itemPrice * itemPcs),2)
            const total = round((round((itemPrice * itemPcs),2) * (1 + (itemVAT /100))),2)
            documentDet.itemVAT1Amount = total - round((itemPrice * itemPcs),2)
            documentDet.itemBaseAmountWithVAT = total
            documentDet.itemBaseForeAmountWithVAT = total
            documentDet.itemAmountWithVAT = total
            documentDet.itemFullTotal = total
            documentDet.itemPriceWithVAT = itemPcs != 0 ? round((total / itemPcs),2) : 0
            documentDet.ExRate = 1
            documentDet.partnerId = this.$store.state.documentActivHead?.partnerId ?? ''
            documentDet.partnerNameDatabase =  this.$store.state.documentActivHead?.partnerNameDatabase ?? ''
            documentDet.itemMargin = this.iMargin
            documentDet.itemMarginAmount = this.iMarginAmount

            documentDet.itemMarginAmount  = (documentDet.itemBaseAmount - documentDet.itemSuppPriceAmount) ? round((documentDet.itemBaseAmount - documentDet.itemSuppPriceAmount),2) : 0
            documentDet.itemMargin = 0
            if (this.iSuppPriceAmount !== 0) {
                documentDet.itemMargin = (documentDet.itemMarginAmount / (documentDet.itemSuppPriceAmount / 100)) ? round((documentDet.itemMarginAmount / (documentDet.itemSuppPriceAmount / 100)),2) : 0
            }
            
            documentDet.FreeF2 = (documentDet.itemMarginAmount  / itemPcs) ? round((documentDet.itemMarginAmount  / itemPcs),2) : 0 

            documentDet.UserId = this.$store.state.user.id ? this.$store.state.user.id : ''
            documentDet.email = this.$store.state.user.email ? this.$store.state.user.email : 'test@cegrupa.com'
            documentDet.First = this.$store.state.user.First ? this.$store.state.user.First : 'NoFirst'
            documentDet.Last = this.$store.state.user.Last ? this.$store.state.user.Last : 'NoLast'
            documentDet.uservatID = this.$store.state.user.vatID ? this.$store.state.user.vatID : '12345678901'
            documentDet.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
            documentDet.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
            documentDet.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024

            // Ako sifra dobavljaca postoji u sifrarniku, stavka odmah dobiva
            // lokalnu sifru i prodajnu cijenu; inace ostaje kakva je bila.
            spojiStavku(documentDet, sifrarnik)

            this.activItems.push(documentDet)
          })
          
          if (this.activItems &&  this.activItems.length > 0) {
            this.javiSpajanje(sifrarnik)
            if (this.activItems) {
                this.$store.dispatch('setDocumentActivItems', this.activItems)
            } else {
                this.$store.dispatch('setDocumentActivItems', [])
            }
            const newTikTok = this.$store.state.tikTok + 1
            this.$store.dispatch('setTikTok', newTikTok)
          }

        }
    },

  }
}
</script>